import { render } from "./IikoIntegration.vue?vue&type=template&id=1c3307dc"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/IikoIntegration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c3307dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c3307dc', __exports__)) {
    api.reload('1c3307dc', __exports__)
  }
  
  module.hot.accept("./IikoIntegration.vue?vue&type=template&id=1c3307dc", () => {
    api.rerender('1c3307dc', render)
  })

}


export default __exports__